/* Solo se carga en temas NO publicados (theme.role != 'main'): contador de maqueta en bucle. */
(function () {
  var els = document.querySelectorAll('[data-countdown-loop]');
  els.forEach(function (el) {
    var total = parseInt(el.getAttribute('data-countdown-loop'), 10) || 4200;
    var left = total;
    function pad(n) { return String(n).padStart(2, '0'); }
    function draw() {
      var h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
      el.innerHTML =
        '<span class="k-countdown__unit"><b>' + pad(h) + '</b><em>h</em></span>' +
        '<span class="k-countdown__unit"><b>' + pad(m) + '</b><em>min</em></span>' +
        '<span class="k-countdown__unit"><b>' + pad(s) + '</b><em>seg</em></span>';
    }
    draw();
    setInterval(function () { left = left > 0 ? left - 1 : total; draw(); }, 1000);
  });
})();
